import React, { useEffect, useState, useMemo } from 'react';
import Paper from '@mui/material/Paper';
import { ACTIVATION_TEXT } from '../../../constants/DashboardConstants';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import './iacmactivation.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { CREATE_ACCOUNT } from '../../../constants/buttonConstants';
import { EMAIL_HINT, PASSWORD_INDI_MSG, PASSWORD_TEXT, USERNAME_HINT } from '../../../constants/settingsPageConstants';
import { validateEmail, validateUserName } from '../../../shared/utils/format.helpers';
import {
  DETAILS_A1,
  DETAILS_A2,
  DETAILS_A3,
  DETAILS_Q1,
  DETAILS_Q2,
  DETAILS_Q3,
  DETAILS_TEXT,
} from '../../../constants/merchantsConstants';
import { createAccountOTTERIACMRequest, createCreateAccountOTTERIACMResponse } from '../../../redux/actions/accountServiceAction';
import { createAccountOTTERIACMResponseSaga } from '../../../redux/saga/accountServiceSelector';
import { AGGREGATOR_TEXT } from '../../../constants/Admin/adminConstants';
import { loadingInProgress } from '../../../redux/actions/loginServiceAction';
import CustomStatusPage from '../../../shared/pages/custom.status';

const IACMActivation = () => {
  const [businessEmailError, setbusinessEmailError] = useState(false);
  const [usernameError, setUsernameError] = useState(false);
  const [formValid, setformValid] = useState(false);
  const [formData, setformData] = useState({
    fields: {
      businessEmail: '',
      username: '',
      confirmpassword: '',
    },
    errors: {},
  });
  const [businessEmailIcon, setbusinessEmailIcon] = useState(null);
  const [usernameErrorIcon, setUsernameErrorIcon] = useState(false);
  const [aggregator, setAggregator] = useState('itsacheckmate');
  const dispatch = useDispatch();
  const createAccountResponse = useSelector(createAccountOTTERIACMResponseSaga);
  const [statusComponent, setStatusComponent] = useState(null);

  useEffect(() => {
    // console.log('RES ',createAccountResponse)
    if (createAccountResponse) {
      dispatch(loadingInProgress(false))
      if (createAccountResponse?.msg) {
        if (createAccountResponse.details?.data?.message) {
          setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
        } else if (createAccountResponse.details?.code === 'ECONNABORTED') {
          setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
        } else {
          setStatusComponent(<CustomStatusPage statusIndicator='User_Creation_Failed' />)
        }
      } else {
        setStatusComponent(<CustomStatusPage statusIndicator='User_Created' />);
      }
    }
    else{
      setStatusComponent(null);
    }
  }, [createAccountResponse]);

  useEffect(()=>{
    dispatch(createCreateAccountOTTERIACMResponse());
  },[])
  
  const crearteAccountHandler = (e) => {
    e.preventDefault();
    if(formValid){
      dispatch(loadingInProgress(true))
      dispatch(
        createAccountOTTERIACMRequest(
          formData.fields.username,
          formData.fields.businessEmail,
          '','',
          aggregator
        )
      );
    }
  };
  const handleChange = (e) => {
    let fields = formData.fields;
    let errors = formData.errors;
    fields[e.target.id] = e.target.value;

    if (e.target.id === 'businessEmail') {
      if (
        formData.fields.businessEmail === '' ||
        (formData.fields.businessEmail &&
          !validateEmail(formData.fields.businessEmail))
      ) {
        setformValid(false);
        setbusinessEmailError(true);
        setbusinessEmailIcon(WarningTriangle);
        errors[e.target.id] = EMAIL_HINT;
      } else {
        setformValid(true);
        setbusinessEmailError(false);
        setbusinessEmailIcon(null);
        delete errors[e.target.id];
      }
    }
    // console.log('fsdf ',e.target.id)
    if (e.target.id === 'username') {
      if (
        formData.fields.username === '' ||
        (formData.fields.username !== '' &&
          !validateUserName(formData.fields.username))
      ) {
        setformValid(false);
        setUsernameError(true);
        setUsernameErrorIcon(WarningTriangle);
        errors[e.target.id] = USERNAME_HINT;
      } else {
        setformValid(true);
        setUsernameError(false);
        setUsernameErrorIcon(null);
        delete errors[e.target.id];
      }
    }

    if (
      formData.fields.username === '' ||
      (formData.fields.username !== '' &&
        !validateUserName(formData.fields.username)) ||
      formData.fields.businessEmail === '' ||
      (formData.fields.businessEmail &&
        !validateEmail(formData.fields.businessEmail))
    ) {
      setformValid(false);
    }
    setformData({ ...formData });
  };

  const handleBrandChnage = (event) => {
    setAggregator(event.target.value);
  };

  return (
    <>
    {statusComponent? statusComponent:
    <><div className='iacm-container' data-testid='iacm-id'>
        <Paper className='page-header'>
          <h4 className='title-class' data-testid='orders-title'>
            {ACTIVATION_TEXT}
          </h4>
        </Paper>
      </div>
      <Divider />
      <div className='iacm-container-body'>
        <Card variant='outlined' className='iacm-container2'>
          <p className='create-iacm-text'>{CREATE_ACCOUNT}</p>
          <Divider />
          <CardContent className='form-activation-container'>
            <form autoComplete='off' onSubmit={crearteAccountHandler}>
              <br />
              <TextField
                id='businessEmail'
				data-testid='iacmbusinessEmail'
                label='Business Email'
                onChange={handleChange}
                required
                variant='outlined'
                color='secondary'
                type='text'
                aria-label='Business Email'
                error={businessEmailError}
                helperText={formData.errors?.businessEmail}
                fullWidth
                sx={{ mb: 3 }}
                inputProps={{ fontSize: '26px' }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {formData.errors?.businessEmail ? (
                        <img src={businessEmailIcon} className='error-icon' />
                      ) : null}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                id='username'
				data-testid='iacmusername'
                label='Username'
                onChange={handleChange}
                required
                variant='outlined'
                color='secondary'
                type='text'
                aria-label='Username'
                error={usernameError}
                helperText={formData.errors?.username}
                fullWidth
                sx={{ mb: 3 }}
                inputProps={{ fontSize: '26px' }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {formData.errors?.username ? (
                        <img src={usernameErrorIcon} className='error-icon' />
                      ) : null}
                    </InputAdornment>
                  ),
                }}
              />
              <FormControl fullWidth>
                <InputLabel id='aggregator-select'>{AGGREGATOR_TEXT}</InputLabel>
                <Select
                  labelId='aggregator-select'
                  id='demo-simple-select'
                  className='select-box'
                  value={aggregator}
                  label='Aggregator'
                  onChange={handleBrandChnage}
                >
                  <MenuItem selected value='itsacheckmate'>itsaCheckmate</MenuItem>
                  <MenuItem selected value='otter'>Otter</MenuItem>
                </Select>
              </FormControl>
              <div className='password-suggestion'>
                <p className='password-main-text'>{PASSWORD_TEXT}</p>
                <p className='password-sub-text'>{PASSWORD_INDI_MSG}</p>
              </div>
              <Divider />
              <div className='form-activation-container-button'>
                <button
                  className='form-activation-container-button--primaryButton'
                  aria-label='Submit Reset Password'
                  disabled={!formValid}
                  variant='outlined'
                  type='submit'
				  data-testid='iacmcreateAccountButton'
                >
                  {CREATE_ACCOUNT}
                </button>
              </div>
            </form>
          </CardContent>
        </Card>
        <br />
        <Card>
          <p className='create-iacm-text'>{DETAILS_TEXT}</p>
          <Divider />
          <CardContent className='question-container'>
            <p className='password-main-text'>{DETAILS_Q1}</p>
            <p className='password-sub-text'>{DETAILS_A1}</p>
            <p className='password-main-text'>{DETAILS_Q2}</p>
            <p className='password-sub-text'>{DETAILS_A2}</p>
            <p className='password-main-text'>{DETAILS_Q3}</p>
            <p className='password-sub-text'>{DETAILS_A3}</p>
          </CardContent>
        </Card>
      </div>
      </>
    }
   </>
  );
};

export default IACMActivation;
